import PropTypes from 'prop-types';

/*
  Component is to be used for links that should open in a new window
  This provides the desktop handler to open in browser
*/

const ExternalLink = ({
  children,
  dataTestId,
  href,
  onClick,
  ...otherProps
}) => (
  <a
    data-testid={dataTestId}
    target="_blank"
    href={href}
    onClick={onClick}
    {...otherProps}
  >
    {children}
  </a>
);

ExternalLink.propTypes = {
  children: PropTypes.node,
  dataTestId: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string,
};

export default ExternalLink;
